import { render, staticRenderFns } from "./PointExpiration.vue?vue&type=template&id=89c813ee"
import script from "./PointExpiration.vue?vue&type=script&lang=js"
export * from "./PointExpiration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports